import gql from 'graphql-tag';

export const getManualNotificationsByAdmin = gql`
  query getManualNotificationsByAdmin($input: inputManualNotifications) {
    getManualNotificationsByAdmin(input: $input) {
      count_rows
      current_page
      can_back
      can_next
      total_page
      notifications {
        id
        type
        title
        description
        messageInSpanish
        messageInEnglish
        createdAt
        user {
          id
          username
          role
        }
        consumer {
          id
          username
        }
      }
    }
  }
`;
